import { render, staticRenderFns } from "./OrthoTreatmentStages.vue?vue&type=template&id=7c9db4e4&"
import script from "./OrthoTreatmentStages.vue?vue&type=script&lang=js&"
export * from "./OrthoTreatmentStages.vue?vue&type=script&lang=js&"
import style0 from "./OrthoTreatmentStages.vue?vue&type=style&index=0&id=7c9db4e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports